import React, { FC } from 'react';
import { Heading } from '@chakra-ui/react';

interface IStudioHeadingProps {
    text: string;
    variant: 'dark' | 'light' | 'primary';
    style?: React.CSSProperties;
}

const StudioHeading: FC<IStudioHeadingProps> = ({ text, variant, style }) => {
    return (
        <Heading as="h2" margin={0} size="sm" style={style} variant={variant}>
            {text}
        </Heading>
    );
};

export default StudioHeading;
